import React from 'react';

import { Register } from './components/Register/Register';
function App() {
  return (
    <div className="App">
        <Register />
    </div>
  );
}

export default App;
